import { Directive, inject, input, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[idealsTranslatedWrapper]',
})
export class TranslatedWrapperDirective {
  readonly elementKey = input.required<string>({ alias: 'idealsTranslatedWrapper' });

  readonly templateRef = inject<TemplateRef<unknown>>(TemplateRef);
  readonly viewRef = inject(ViewContainerRef);
}
